import type {NamedSetState} from 'app/gemStore/devtools';

import type {HeaderSwitchToMobileSlice} from './types';

export const createHeaderSwitchToMobileSlice = (set: NamedSetState<HeaderSwitchToMobileSlice>) => ({
    headerSwitchToMobile: false,
    setHeaderSwitchToMobile: (headerSwitchToMobile: boolean) => set({headerSwitchToMobile}, false, 'headerSwitchToMobile/setHeaderSwitchToMobile'),
});
